import React, { useCallback } from "react";
import { Button, Popconfirm } from "antd";
import { FormattedMessage } from "react-intl";
import { DeleteOutlined } from "@ant-design/icons";
import { useParams, useSearchParams } from "react-router-dom";

import MQTTService from "../../services/mqtt";
import { MESSAGE_TYPE } from "../../lib/utils/constants";

const NodeAnalyticsRemoveResults = () => {
  const { cwid } = useParams();
  const [searchParams] = useSearchParams();
  const channelId = searchParams.get("c");

  const handleClearAlerts = useCallback(() => {
    MQTTService.sendMessageV5({
      topic: `node/${cwid}/in`,
      message: {
        msgType: MESSAGE_TYPE.CLEAR_LAST_TEST_RESULTS,
        channelId,
      },
    });
  }, [cwid, channelId]);

  return (
    <Popconfirm
      placement="top"
      title={
        <FormattedMessage
          id="NodeAnalyticsRemoveResults.deleteAlertsConfirmation"
          defaultMessage="Are you sure you want to clear results for this channel?"
        />
      }
      okText={<FormattedMessage id="general.yes" defaultMessage="Yes" />}
      cancelText={<FormattedMessage id="general.no" defaultMessage="No" />}
      onConfirm={handleClearAlerts}
    >
      <Button type="primary" danger disabled={!channelId}>
        <>
          <DeleteOutlined />{" "}
          <FormattedMessage id="NodeAnalyticsRemoveResults.deleteAlerts" defaultMessage="Clear results" />
        </>
      </Button>
    </Popconfirm>
  );
};
export default NodeAnalyticsRemoveResults;
